module.exports = __webpack_public_path__ + "media/images/icons/outlined/gitlab-46955b08213478fc483fd97e2c07de5d.svg";